import React from "react";
import { SMSTemplateForm } from "./SMSTemplateForm";

const CreateSMSTemplatePage: React.FC = () => {
  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4">
        <h2 className="text-base lg:text-lg font-semibold text-gray-900">
          Create SMS Template
        </h2>
        <p className="text-xs lg:text-sm text-gray-500">
          Create a reusable SMS message for reminders and campaigns.
        </p>
      </div>
      <SMSTemplateForm />
    </div>
  );
};

export default CreateSMSTemplatePage;

